// AdminAdmitCardEntry.jsx
import React, { useState } from "react";
import AdminHeader from "./AdminHeader";
import API_BASE_URL from "./api";
function genId() {
  return Math.random().toString(36).slice(2, 9);
}

const defaultSections = [
  {
    id: genId(),
    title: "Important Details",
    rows: [
      { id: genId(), key: "exam_city", value: "" },
      { id: genId(), key: "exam_shift", value: "" }
    ]
  }
];

export default function AdminAdmitCardEntry() {
  const [admitName, setAdmitName] = useState("");
  const [examDate, setExamDate] = useState("");
  const [organization, setOrganization] = useState("");
  const [downloadLink, setDownloadLink] = useState("");

  const [sections, setSections] = useState(defaultSections);

  const [msg, setMsg] = useState("");

  // --------------------- BUILD JSON ---------------------------
  const buildJson = () => {
    const json = {
      admit_name: admitName,
      exam_date: examDate,
      organization: organization,
      download_link: downloadLink,
      sections: {}
    };

    for (const s of sections) {
      const sec = {};
      for (const r of s.rows) {
        sec[r.key || r.id] = r.value;
      }
      json.sections[s.title] = sec;
    }

    return json;
  };

  // --------------------- SECTION FUNCTIONS ---------------------
  const addSection = () =>
    setSections(prev => [
      ...prev,
      {
        id: genId(),
        title: "New Section",
        rows: [{ id: genId(), key: "key1", value: "" }]
      }
    ]);

  const removeSection = id =>
    setSections(prev => prev.filter(sec => sec.id !== id));

  const addRow = sectionId =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? {
            ...sec,
            rows: [...sec.rows, { id: genId(), key: "", value: "" }]
          }
          : sec
      )
    );

  const removeRow = (sectionId, rowId) =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? { ...sec, rows: sec.rows.filter(r => r.id !== rowId) }
          : sec
      )
    );

  const updateRow = (sectionId, rowId, field, value) =>
    setSections(prev =>
      prev.map(sec =>
        sec.id === sectionId
          ? {
            ...sec,
            rows: sec.rows.map(r =>
              r.id === rowId ? { ...r, [field]: value } : r
            )
          }
          : sec
      )
    );

  // --------------------- SUBMIT ---------------------
  const handleSubmit = async () => {
    try {
      const userEmail = localStorage.getItem("userEmail");
      const user_mobileno = localStorage.getItem("user_mobileno");

      if (!userEmail || !user_mobileno) {
        alert("Login details missing. Please login again.");
        return;
      }

      const payload = {
        ...buildJson(),
        //userEmail: userEmail,
        user_mobileno: user_mobileno
      };

      //const payload = buildJson();

      const response = await fetch(
        `${API_BASE_URL}/api/admitcard/submit`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();

      if (data.success) {
        setMsg("Admit Card inserted successfully!");
        alert("Admit Card inserted successfully!");
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      alert("Network Error: " + err.message);
    }
  };

  // --------------------- UI ---------------------
  return (
    <div>
      <AdminHeader />

      <main
        style={{
          padding: 20,
          marginTop: 72,
          display: "grid",
          gridTemplateColumns: "1fr 380px",
          gap: 16
        }}
      >
        {/* LEFT SIDE */}
        <section>
          <h2>Admit Card Entry</h2>

          <label>Admit Card Name</label>
          <input
            value={admitName}
            onChange={e => setAdmitName(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Exam Date</label>
          <input
            type="date"
            value={examDate}
            onChange={e => setExamDate(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Organization</label>
          <input
            value={organization}
            onChange={e => setOrganization(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          <label>Download Link (PDF / Image)</label>
          <input
            value={downloadLink}
            onChange={e => setDownloadLink(e.target.value)}
            style={{ width: "100%", padding: 8, marginBottom: 10 }}
          />

          {/* SECTIONS */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <h3>Sections</h3>
            <button onClick={addSection}>+ Add Section</button>
          </div>

          {sections.map(s => (
            <div
              key={s.id}
              style={{
                border: "1px solid #ddd",
                padding: 10,
                marginBottom: 10,
                background: "#fff"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                <input
                  value={s.title}
                  onChange={e =>
                    setSections(prev =>
                      prev.map(x =>
                        x.id === s.id ? { ...x, title: e.target.value } : x
                      )
                    )
                  }
                  style={{ fontWeight: "bold" }}
                />
                <div>
                  <button
                    onClick={() => addRow(s.id)}
                    style={{ marginRight: 8 }}
                  >
                    + Row
                  </button>
                  <button
                    onClick={() => removeSection(s.id)}
                    style={{ color: "red" }}
                  >
                    Remove
                  </button>
                </div>
              </div>

              {/* Rows */}
              <div style={{ marginTop: 8 }}>
                {s.rows.map(r => (
                  <div
                    key={r.id}
                    style={{
                      display: "flex",
                      gap: 8,
                      marginBottom: 6
                    }}
                  >
                    <input
                      placeholder="key"
                      value={r.key}
                      onChange={e =>
                        updateRow(s.id, r.id, "key", e.target.value)
                      }
                      style={{ width: "40%", padding: 6 }}
                    />
                    <input
                      placeholder="value"
                      value={r.value}
                      onChange={e =>
                        updateRow(s.id, r.id, "value", e.target.value)
                      }
                      style={{ width: "50%", padding: 6 }}
                    />
                    <button
                      onClick={() => removeRow(s.id, r.id)}
                      style={{ color: "red" }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button onClick={handleSubmit}>Submit</button>

            <button
              onClick={() => {
                setSections(defaultSections);
                setAdmitName("");
                setExamDate("");
                setOrganization("");
                setDownloadLink("/uploads/sample.png");
                setMsg("");
              }}
            >
              Reset
            </button>
          </div>

          {msg && <div style={{ marginTop: 10 }}>{msg}</div>}
        </section>

        {/* RIGHT SIDE */}
        <aside>
          <h3>JSON Preview</h3>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              background: "#111",
              color: "#b7f5d7",
              padding: 12,
              borderRadius: 6,
              height: "60vh",
              overflow: "auto"
            }}
          >
            {JSON.stringify(buildJson(), null, 2)}
          </pre>

          <h3>Preview</h3>
          <div
            style={{
              border: "1px solid #ddd",
              padding: 8,
              background: "#fff",
              borderRadius: 6
            }}
          >
            <img
              src={downloadLink}
              alt="admit"
              style={{ width: "100%", objectFit: "contain" }}
            />
          </div>
        </aside>
      </main>
    </div>
  );
}

